// extracted by mini-css-extract-plugin
module.exports = {"title":"InfoLabel_title__3cs1y"};